const translations = {
  pt: {
    editBooks: "Editar Livros",
    backToBooks: "Voltar para seleção de livros",
    addNewBook: "Adicionar Novo Livro",
    bookTitlePlaceholder: "Título do livro",
    addButton: "Adicionar",
    availableBooks: "Livros Disponíveis",
    chapters: "capítulos",
    visible: "Visível",
    hidden: "Oculto",
    editing: "Editando: ",
    saveTitle: "Salvar Título",
    hideBook: "Ocultar Livro",
    publishBook: "Publicar Livro",
    addChapter: "Adicionar Capítulo",
    chapterTitlePlaceholder: "Título do capítulo",
    defaultOwner: "Proprietário do Livro (padrão)",
    create: "Criar",
    existingChapters: "Capítulos Existentes",
    noOwner: "Sem proprietário",
    backToChapters: "Voltar para seleção de capítulos",
    chapterOwner: "Proprietário do Livro",
    saveChanges: "Salvar Alterações",
    hideChapter: "Ocultar Capítulo",
    publishChapter: "Publicar Capítulo",
    editContent: "Editar Conteúdo",
    viewTasks: "Ver Tarefas",
    suggestions: "Sugestões",
    delete: "Apagar",
    forward: "Repassar",
    tasksFor: 'Tarefas de "',
    backToChapterEdit: "Voltar para edição de capítulo",
    instructions: "Instruções:",
    none: "Nenhuma",
    comments: "Comentários:",
    dataLoadError: "Falha ao carregar dados: ",
    relatedDataError: "Falha ao carregar dados relacionados: ",
    bookAddSuccess: "Livro adicionado com sucesso",
    bookAddError: "Falha ao adicionar livro: ",
    chapterAddSuccess: "Capítulo adicionado com sucesso",
    chapterAddError: "Falha ao adicionar capítulo... ",
    titleUpdateSuccess: "Título do livro atualizado com sucesso",
    titleUpdateError: "Falha ao atualizar título do livro... ",
    chapterUpdateSuccess: "Capítulo atualizado com sucesso",
    chapterUpdateError: "Falha ao atualizar capítulo... ",
    commentDeleted: "Comentário apagado com sucesso",
    commentForwarded: "Comentário repassado com sucesso",
    commentActionError: "Falha ao atualizar comentário: ",
    taskUpdateSuccess: "Tarefa marcada como ",
    stateOpen: "aberta",
    stateClosed: "fechada",
    taskUpdateError: "Falha ao atualizar tarefa: ",
    bookPublished: "Livro publicado com sucesso",
    bookHidden: "Livro ocultado com sucesso",
    visibilityUpdateError: "Falha ao atualizar visibilidade... ",
    pageNumber: "Página: ",
    by: "por",
    chaptersReordered: "Ordem dos capítulos atualizada com sucesso",
    reorderError: "Falha ao reordenar capítulos...",
    defaultErrorMessage: "Primeiramente, verifique se algum capítulo possui leitor como editor. Caso persista, tente novamente mais tarde. ",
    reorderingChapters: "Reordenando capítulos...",
    loadingData: "Carregando dados...",
    adding: "Adicionando...",
    creating: "Criando...",
    saving: "Salvando...",
    updating: "Atualizando...",
    confirmDeleteChapter: "Tem certeza que deseja apagar este capítulo?",
    chapterDeleteSuccess: "Capítulo apagado com sucesso",
    chapterDeleteError: "Falha ao apagar capítulo, verifique se existe comentário ou tarefa associada a ele. Erro: ",
    deleteChapter: "Apagar Capítulo",
    deleting: "Apagando...",
    deleteAlert: "Para deletar um capítulo, o capítulo precisa ser nomeado 'delete'. E não deve ter tarefas vinculadas a ele.",
    deleteMessage: "Está ação apagará o capítulo permanentemente. Caso o capítulo possua tarefas vinculadas, a ação falhará.",
    understood: "Entendido",
    cancel: "Cancelar",
    chapterLoadError: "Erro ao carregar capítulo: ",
    contextPlaceholder: "Forneça o contexto do capítulo...",
    showing: "Mostrando",
    of: " de ",
    commentsLow: "comentários",
    context: "Contexto",
    chapterTitle: "Título do Capítulo",
    onlyProducts: "Apenas Produtos",
  },
  en: {
    editBooks: "Edit Books",
    backToBooks: "Back to book selection",
    addNewBook: "Add New Book",
    bookTitlePlaceholder: "Book title",
    addButton: "Add",
    availableBooks: "Available Books",
    chapters: "chapters",
    visible: "Visible",
    hidden: "Hidden",
    editing: "Editing: ",
    saveTitle: "Save Title",
    hideBook: "Hide Book",
    publishBook: "Publish Book",
    addChapter: "Add Chapter",
    chapterTitlePlaceholder: "Chapter title",
    defaultOwner: "Book Owner (default)",
    create: "Create",
    existingChapters: "Existing Chapters",
    noOwner: "No owner",
    backToChapters: "Back to chapter selection",
    chapterOwner: "Book Owner",
    saveChanges: "Save Changes",
    hideChapter: "Hide Chapter",
    publishChapter: "Publish Chapter",
    editContent: "Edit Content",
    viewTasks: "View Tasks",
    suggestions: "Suggestions",
    delete: "Delete",
    forward: "Forward",
    tasksFor: 'Tasks for "',
    backToChapterEdit: "Back to chapter editing",
    instructions: "Instructions:",
    none: "None",
    comments: "Comments:",
    dataLoadError: "Failed to load data: ",
    relatedDataError: "Failed to load related data: ",
    bookAddSuccess: "Book added successfully",
    bookAddError: "Failed to add book... ",
    chapterAddSuccess: "Chapter added successfully",
    chapterAddError: "Failed to add chapter... ",
    titleUpdateSuccess: "Book title updated successfully",
    titleUpdateError: "Failed to update book title... ",
    chapterUpdateSuccess: "Chapter updated successfully",
    chapterUpdateError: "Failed to update chapter... ",
    commentDeleted: "Comment deleted successfully",
    commentForwarded: "Comment forwarded successfully",
    commentActionError: "Failed to update comment: ",
    taskUpdateSuccess: "Task marked as ",
    stateOpen: "open",
    stateClosed: "closed",
    taskUpdateError: "Failed to update task: ",
    bookPublished: "Book published successfully",
    bookHidden: "Book hidden successfully",
    visibilityUpdateError: "Failed to update visibility: ",
    pageNumber: "Page: ",
    by: "by",
    chaptersReordered: "Chapters reordered successfully",
    reorderError: "Failed to reorder chapters...",
    defaultErrorMessage: "First, check if any chapter has reader as editor. If the problem persists, try again later. ",
    reorderingChapters: "Reordering chapters...",
    loadingData: "Loading data...",
    adding: "Adding...",
    creating: "Creating...",
    saving: "Saving...",
    updating: "Updating...",
    confirmDeleteChapter: "Are you sure you want to delete this chapter?",
    chapterDeleteSuccess: "Chapter deleted successfully",
    chapterDeleteError: "Failed to delete chapter, check if there are comment or tasks associated with it. Error: ",
    deleteChapter: "Delete Chapter",
    deleting: "Deleting...",
    deleteAlert: "To delete a chapter, it must be named 'delete'. It should not have any tasks linked to it.",
    deleteMessage: "This action will permanently delete the chapter. If the chapter has linked tasks, the action will fail.",
    understood: "Understood",
    cancel: "Cancel",
    chapterLoadError: "Error loading chapter: ",
    contextPlaceholder: "Provide chapter context...",
    showing: "Showing",
    of: " of ",
    commentsLow: "comments",
    context: "Context",
    chapterTitle: "Chapter Title",
    onlyProducts: "Only Products",
  },
};

export default translations;